import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { OFERTAS_ABERTAS_BASE_ROUTES } from './ofertas-abertas-base.route';
import { syncRoutesWithFeature } from '../../shared/routes/feature-routes.util';

export const OFERTAS_ABERTAS_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    syncRoutesWithFeature(routesService, configState, 'cargo_fleet.Leilao', [
      ...OFERTAS_ABERTAS_BASE_ROUTES,
    ]);
  };
}
